import React from 'react'
import { Flex, Box, Label, Checkbox, Text } from 'pcln-design-system'
import { useRouter } from 'next/router'
import { ProductOption } from '../Flights/types'
import analytics from '../../utils/analytics'

type ProductCheckBoxType = {
  category: string
  productOptions: Readonly<ProductOption[]>
  tripType: string
  label: string
  setValue: (key: string, value: string) => void
  color?: string
  children?: any
}

export default function ProductCheckBox({
  children, // PKG_ADDITIONAL_HOTEL_LINK_NEW_HOTEL_LANDING
  category,
  productOptions,
  tripType,
  label,
  setValue,
  color = 'gray'
}: ProductCheckBoxType) {
  const {
    query: { tab = 'hotels' },
    pathname
  } = useRouter()
  const isHomepage = pathname === '/'
  const parent = isHomepage ? `${tab}-` : ''
  return (
    <>
      <Flex alignItems="center">
        <Text fontSize={0} color={color} pr={[1, 2, null, 3]}>
          {label}
        </Text>
        <Flex flexWrap="wrap" alignItems="center">
          {productOptions.map(option => {
            const checked = tripType.includes(option.type)
            return (
              <Box key={option.name} mt="2px" pr={[1, 2, 3]}>
                <Label fontSize={0} htmlFor={option.id} color={color}>
                  <Checkbox
                    aria-label={option.label}
                    id={option.id}
                    data-testid={option.id}
                    name={option.name}
                    value={option.type}
                    checked={checked}
                    onChange={(
                      e: React.ChangeEvent<HTMLInputElement>
                    ): void => {
                      let value = tripType
                      if (e.target.checked) {
                        value = `${tripType}:${e.target.value}`
                        analytics.fireEvent({
                          action: 'Add Product Checkbox',
                          category,
                          label: `${parent}${option.label}`
                        })
                      } else {
                        value = tripType.replace(`:${e.target.value}`, '')
                      }
                      setValue('tripType', value)
                    }}
                  />
                  {` ${option.label} `}
                </Label>
              </Box>
            )
          })}
          {children}
        </Flex>
      </Flex>
    </>
  )
}
